import { brands, BrandType } from 'noddi-types';
import dekkfixServiceCenterAvif from '../../../../assets/images/dekkfix/booking-choice/service-center.avif';
import dekkfixServiceCenterJpg from '../../../../assets/images/dekkfix/booking-choice/service-center.jpg';
import dekkfixServiceCenterWebp from '../../../../assets/images/dekkfix/booking-choice/service-center.webp';
import dekkfixBrandAvif from '../../../../assets/images/dekkfix/brand-image/dekkfix.avif';
import dekkfixBrandJpg from '../../../../assets/images/dekkfix/brand-image/dekkfix.jpg';
import dekkfixBrandWebp from '../../../../assets/images/dekkfix/brand-image/dekkfix.webp';
import homeDeliveryAvif from '../../../../assets/images/tronderdekk/booking-choice/home-delivery.avif';
import homeDeliveryJpg from '../../../../assets/images/tronderdekk/booking-choice/home-delivery.jpg';
import homeDeliveryWebp from '../../../../assets/images/tronderdekk/booking-choice/home-delivery.webp';
import workshopAvif from '../../../../assets/images/tronderdekk/booking-choice/workshop.avif';
import workshopJpg from '../../../../assets/images/tronderdekk/booking-choice/workshop.jpg';
import workshopWebp from '../../../../assets/images/tronderdekk/booking-choice/workshop.webp';

export interface BookingChoicePhoto {
  avif: string;
  webp: string;
  jpg: string;
}

interface BookingChoicePhotoSet {
  homeDelivery: BookingChoicePhoto;
  serviceCenter: BookingChoicePhoto;
}

// AVIF + WebP with JPG fallback, same pattern as BrandImage. Brands without
// photos render the choice cards without a photo block.
const photosByBrand: Partial<Record<BrandType, BookingChoicePhotoSet>> = {
  [brands.dekkfix]: {
    // Placeholder until Dekkfix has a home-delivery photo of their own.
    homeDelivery: { avif: dekkfixBrandAvif, webp: dekkfixBrandWebp, jpg: dekkfixBrandJpg },
    serviceCenter: {
      avif: dekkfixServiceCenterAvif,
      webp: dekkfixServiceCenterWebp,
      jpg: dekkfixServiceCenterJpg
    }
  },
  [brands.tronderdekk]: {
    homeDelivery: { avif: homeDeliveryAvif, webp: homeDeliveryWebp, jpg: homeDeliveryJpg },
    serviceCenter: { avif: workshopAvif, webp: workshopWebp, jpg: workshopJpg }
  }
};

export const getBookingChoicePhotos = (brand: BrandType) => photosByBrand[brand];
